module.exports = __webpack_public_path__ + "static/media/goodcall.0cc85c35.png";